import { useGet } from '../../api/queries/useGet';

export const useGetIsCloudOnlyRequest = () => {
    const {
        data: isCloudOnly,
        error,
        loading
    } = useGet<boolean>({
        url: '/license/getIsCloudOnly',
        enabled: true
    });

    return { isCloudOnly, error, loading };
};
